

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class APPCC_TaskResult_ManagedObject

class APPCC_TaskResult_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: date
    set date(value:Date) {
        this.setValueForKey(value, 'date');
    }
    get date():Date {
        return this.valueForKey('date');
    }
    set datePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'date');
    }
    get datePrimitiveValue():Date {
        return this.primitiveValueForKey('date');
    }

    // Property: imageID
    set imageID(value:string) {
        this.setValueForKey(value, 'imageID');
    }
    get imageID():string {
        return this.valueForKey('imageID');
    }
    set imageIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'imageID');
    }
    get imageIDPrimitiveValue():string {
        return this.primitiveValueForKey('imageID');
    }

    // Property: observations
    set observations(value:string) {
        this.setValueForKey(value, 'observations');
    }
    get observations():string {
        return this.valueForKey('observations');
    }
    set observationsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'observations');
    }
    get observationsPrimitiveValue():string {
        return this.primitiveValueForKey('observations');
    }

    // Property: status
    set status(value:number) {
        this.setValueForKey(value, 'status');
    }
    get status():number {
        return this.valueForKey('status');
    }
    set statusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'status');
    }
    get statusPrimitiveValue():number {
        return this.primitiveValueForKey('status');
    }

    // Property: usedProducts
    set usedProducts(value:string) {
        this.setValueForKey(value, 'usedProducts');
    }
    get usedProducts():string {
        return this.valueForKey('usedProducts');
    }
    set usedProductsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'usedProducts');
    }
    get usedProductsPrimitiveValue():string {
        return this.primitiveValueForKey('usedProducts');
    }

    // Property: value
    set value(value:number) {
        this.setValueForKey(value, 'value');
    }
    get value():number {
        return this.valueForKey('value');
    }
    set valuePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'value');
    }
    get valuePrimitiveValue():number {
        return this.primitiveValueForKey('value');
    }

    // Property: workerName
    set workerName(value:string) {
        this.setValueForKey(value, 'workerName');
    }
    get workerName():string {
        return this.valueForKey('workerName');
    }
    set workerNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'workerName');
    }
    get workerNamePrimitiveValue():string {
        return this.primitiveValueForKey('workerName');
    }
    // Relationship: image
    set image(value:DBImage) {
        this.setValueForKey(value, 'image');
    }
    get image():DBImage {
        return this.valueForKey('image') as DBImage;
    }
    // Relationship: task
    set task(value:APPCC_Task) {
        this.setValueForKey(value, 'task');
    }
    get task():APPCC_Task {
        return this.valueForKey('task') as APPCC_Task;
    }
    // Relationship: worker
    set worker(value:Employee) {
        this.setValueForKey(value, 'worker');
    }
    get worker():Employee {
        return this.valueForKey('worker') as Employee;
    }
}
